import Vue from 'vue'
import soundService from '@/services/SoundService'

Vue.directive('menuHoverSound', {
    bind: function (el, binding, vnode) {
        vnode.context.function = function() {
            soundService.play('menuHover')
        }
        el.addEventListener('mouseenter', vnode.context.function)
    },
    unbind: function (el, binding, vnode) {
        el.removeEventListener('mouseenter', vnode.context.function)
    }
})